module.exports = require("core-js-pure/stable/json/stringify");